import { Component, inject, OnInit } from '@angular/core';
import { UserdataService } from '../../../service/userdata.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-upload-ragger',
  standalone: false,
  templateUrl: './upload-ragger.component.html',
  styleUrl: './upload-ragger.component.scss'
})
export class UploadRaggerComponent implements OnInit {
  userService = inject(UserdataService);
  dialog = inject(MatDialogRef<UploadRaggerComponent>);
  user: any;

  async ngOnInit(): Promise<void> {
    this.user = await this.userService.getUserDataByKey("prename");
    console.log(this.user);

  }

  close(data: any = undefined): void {
    this.dialog.close(data);
  }

}
